jQ('.js-search-trigger').on('click', function() {
  jQ('body').addClass('bc-sf-custom-open-search-mobile');
});

// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'right',
        //suggestionWidth: 'auto'
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {

};